import React, { useContext, useLayoutEffect } from 'react'
import PortalContext from './PortalContext'

interface PortalPreviewProps {
  name: string
  onReady?: () => void
}
const PortalPreview = ({ name, onReady }: PortalPreviewProps) => {
  const { getComponent } = useContext(PortalContext)
  const component = getComponent(name)

  useLayoutEffect(() => {
    if (component) {
      onReady?.()
    }
  }, [component, onReady])

  return <>{component}</>
}
export default PortalPreview
